import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaSearch, FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa'
import { useColorScheme } from '@/contexts/ThemeContext'

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const { colorScheme } = useColorScheme()

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    // Implementar lógica de busca
    setSearchQuery('')
    setIsSearchOpen(false)
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-light-primary transition-colors duration-200 dark:bg-dark-primary">
      <div className="absolute bottom-0 left-0 right-0 h-[1px]" style={{
        background: `linear-gradient(to right, transparent, ${colorScheme === 'brand' ? 'rgba(56, 189, 248, 0.5)' : 'rgba(2, 132, 199, 0.5)'} 20%, ${colorScheme === 'brand' ? 'rgba(56, 189, 248, 0.5)' : 'rgba(2, 132, 199, 0.5)'} 80%, transparent)`
      }}></div>
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src="/logo-e-icon/logo-orig.png"
                alt="Logo UniãoFerr"
                className="h-10 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Menu */}
          <nav className="hidden md:flex flex-1 justify-center">
            <ul className="flex items-center space-x-10 mx-8">
              <li>
                <a
                  href="#hero"
                  className="relative text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-all duration-300 ease-in-out after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-light-accent dark:after:bg-dark-accent after:transition-all after:duration-300 hover:after:w-full"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="relative text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-all duration-300 ease-in-out after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-light-accent dark:after:bg-dark-accent after:transition-all after:duration-300 hover:after:w-full"
                >
                  Serviços
                </a>
              </li>
              <li>
                <a
                  href="#trabalhos"
                  className="relative text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-all duration-300 ease-in-out after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-light-accent dark:after:bg-dark-accent after:transition-all after:duration-300 hover:after:w-full"
                >
                  Portfólio
                </a>
              </li>
              <li>
                <a
                  href="#partners"
                  className="relative text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-all duration-300 ease-in-out after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-light-accent dark:after:bg-dark-accent after:transition-all after:duration-300 hover:after:w-full"
                >
                  Parceiros
                </a>
              </li>
              <li>
                <a
                  href="#contato"
                  className="relative text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-all duration-300 ease-in-out after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-light-accent dark:after:bg-dark-accent after:transition-all after:duration-300 hover:after:w-full"
                >
                  Contato
                </a>
              </li>
            </ul>
          </nav>
          
          {/* Right side elements */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Social Icons */}
            <div className="flex items-center space-x-4">
              <a
                href="https://www.instagram.com/uniaoferr.oficial/#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-transform duration-300 hover:scale-125"
                aria-label="Instagram"
              >
                <FaInstagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/uniaoferr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-transform duration-300 hover:scale-125"
                aria-label="Facebook"
              >
                <FaFacebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com/@uniaoferr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-light-primary hover:text-light-accent dark:text-dark-primary dark:hover:text-dark-accent transition-transform duration-300 hover:scale-125"
                aria-label="YouTube"
              >
                <FaYoutube className="h-5 w-5" />
              </a>
            </div>
            
            {/* Search Button */}
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md p-2 text-light-primary hover:bg-light-secondary hover:text-light-accent focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent transition-all duration-300 hover:scale-110 transform hover:shadow-md"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
            >
              <FaSearch className="h-5 w-5" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center space-x-4 md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center rounded-md p-2 text-light-primary hover:bg-light-secondary hover:text-light-accent focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent transition-all duration-300 hover:scale-110 transform hover:shadow-md"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Abrir menu principal</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              <a
                href="#hero"
                className="block rounded-md px-3 py-2 text-base font-medium text-light-primary hover:bg-light-secondary hover:text-light-accent dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent"
              >
                Home
              </a>
              <a
                href="#services"
                className="block rounded-md px-3 py-2 text-base font-medium text-light-primary hover:bg-light-secondary hover:text-light-accent dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent"
              >
                Serviços
              </a>
              <a
                href="#trabalhos"
                className="block rounded-md px-3 py-2 text-base font-medium text-light-primary hover:bg-light-secondary hover:text-light-accent dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent"
              >
                Portfólio
              </a>
              <a
                href="#partners"
                className="block rounded-md px-3 py-2 text-base font-medium text-light-primary hover:bg-light-secondary hover:text-light-accent dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent"
              >
                Parceiros
              </a>
              <a
                href="#contato"
                className="block rounded-md px-3 py-2 text-base font-medium text-light-primary hover:bg-light-secondary hover:text-light-accent dark:text-dark-primary dark:hover:bg-dark-secondary dark:hover:text-dark-accent"
              >
                Contato
              </a>
            </div>
          </div>
        )}

        {/* Search Bar */}
        {isSearchOpen && (
          <div className="absolute left-0 right-0 top-16 bg-light-primary p-4 shadow-lg transition-colors duration-200 dark:bg-dark-primary">
            <form onSubmit={handleSearch} className="flex items-center">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-md border border-light-primary bg-light-secondary px-4 py-2 text-light-primary placeholder-light-secondary focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-dark-primary dark:bg-dark-secondary dark:text-dark-primary dark:placeholder-dark-secondary"
                placeholder="Buscar..."
              />
              <button
                type="submit"
                className="ml-2 rounded-md bg-light-accent p-2 text-white hover:bg-primary-700 dark:bg-dark-accent dark:hover:bg-primary-800"
              >
                <FaSearch className="h-5 w-5" />
              </button>
            </form>
          </div>
        )}
      </div>
    </header>
  )
} 